module.exports = __webpack_public_path__ + "fonts/VideoJS.eot?v=00103e881a36640a08f869ff6888f0fd";


//////////////////
// WEBPACK FOOTER
// ./~/video.js/dist/font/VideoJS.eot
// module id = 640
// module chunks = 0